<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    rounding?: string
    background?: string
    boxShadow?: string | boolean
  }>(),
  {
    rounding: 'rounded',
    background: 'bg-default',
    boxShadow: false
  }
)

const shadowClass = computed(() => {
  if (typeof props.boxShadow === 'string') {
    return props.boxShadow
  } else if (props.boxShadow) {
    return 'shadow'
  } else {
    return undefined
  }
})
</script>

<template>
  <div :class="[rounding, background, shadowClass]">
    <slot />
  </div>
</template>
